<template>
    <b-row v-bind:class="[{ busy: busy || loadingPrice}, 'special-article-mobile  p-2 mb-2', 'opacity-transition']">
        <pb-spinner v-if="busy || loadingPrice"></pb-spinner>
        <b-col class="p-2">
            <b-row>
                <b-col>
                    <div class="image">
                        <router-link
                                :to="{ name: 'ar', params: {articleId: article.id, categoryId: category.id, variantId: article.colorId} }">
                            <img class="card-img-top" :src="fileResourceUrl(article.webImage)" alt="Card image cap"/>
                        </router-link>
                    </div>
                </b-col>
                <b-col>
                    <p class="article-number">
                        <small>{{article.name}}</small>
                        <br/>
                        <small>{{customerArticleNumber}}</small>
                    </p>
                    <p class="article-name">{{article.primaryDescription || article.secondaryDescription}}</p>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <b-button class="p-0"
                              :to="{ name: 'ar', params: {articleId: article.id, categoryId: category.id, variantId: article.colorId} }"
                              variant="link"><span
                            class="icon-eye mr-1"></span> DETAILS
                    </b-button>
                </b-col>
                <b-col>
                    <b-button class="p-0" variant="link"><span class="icon-sheet"></span>DATASHEET
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="isApproved">
                <b-col>
                    <custom-select @click.native="fetchArticleDetails"
                                   type="sm"
                                   @select="selectSize"
                                   :value="selectedSize" label="SIZE"
                                   :options="sizeOptions"></custom-select>
                </b-col>
                <b-col>
                    <custom-select @click.native="fetchArticleDetails"
                                   type="sm"
                                   @select="selectColor"
                                   :value="selectedColor" label="COLOR"
                                   :options="colorOptions"></custom-select>
                </b-col>
            </b-row>
            <b-row v-if="isApproved">
                <b-col>
                    <b-row>
                        <b-col>
                             <span class="pricing" v-if="articlePrice">
                                    {{ articlePrice.price | currency($currencyFormatting[articlePrice.currency])}}
                                </span>
                        </b-col>
                        <b-col>
                            <b-form-input
                                    :disabled="(!articlePrice) || (isPurchaseLocked && (articlePrice && articlePrice.samplePrice <= 0.0))"
                                    class="text-center"
                                    type="text"
                                    name="amount"
                                    placeholder="QUANTITY"
                                    v-model="amount"
                                    v-validate="amountValidationRule"
                                    :state="validateState('amount')">
                            </b-form-input>
                        </b-col>
                    </b-row>


                </b-col>
                <b-col>
                    <pb-btn :busy="submitProcessing"
                            :disabled="isPurchaseLocked"
                            icon="fa-plus fa-sm" block
                            v-on:click.native="onAddToCart()"
                            variant="primary">
                        ADD TO BAG
                    </pb-btn>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>

    import CustomerCategoryArticleBase from "./CustomerCategoryArticleBase";

    export default {
        name: 'cutomer-category-article-mobile',
        extends: CustomerCategoryArticleBase
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .special-article-mobile {
        background-color: #F1F1F1;
        background-clip: content-box;
        position: relative;
        .image {

            padding: 20px;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                margin: auto;
            }
        }

        .article-name {
            color: $color-primary-dark;
            font-family: $font-robo;
            font-size: 18px;
            font-weight: 300;
            letter-spacing: 1.5px;
            line-height: 24px;
        }

        .content {
            background-color: #F1F1F1;
            padding: 20px;
            height: 100%;
        }

        .pricing {
            float: right;
            line-height: 34px;
        }
    }
</style>
